<template>
  <div
    :class="[
      ns.b('group'),
      ns.bm('group', size),
      ns.is('rounded', rounded),
      ns.is('compact', compact),
    ]"
    data-test-name="button-group"
    data-test-variant=""
    data-test-state=""
  >
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { provide, reactive, toRef } from 'vue'
import { buttonGroupContextKey } from '@bigin/tokens'
import { useNamespace } from '@bigin/hooks'
import { buttonGroupProps } from './button-group'

defineOptions({
  name: 'BButtonGroup',
})
const props = defineProps(buttonGroupProps)
provide(
  buttonGroupContextKey,
  reactive({
    size: toRef(props, 'size'),
    type: toRef(props, 'type'),
    rounded: toRef(props, 'rounded'),
  })
)
const ns = useNamespace('button')
</script>
